import { useLocation } from 'react-router-dom';
import { shouldUseTacticoreAuthoringChrome } from '../../shared/tacticore/tacticoreAuthoringPaths';
import { isTacticoreUnitStructureUxUiEnabled } from '../hooks/useTacticoreUnitStructureUx';

/** True when TactiCore app chrome paths should use immersive header + mini footer. */
export function useTacticoreAuthoringChromeActive(): boolean {
  const { pathname } = useLocation();
  return shouldUseTacticoreAuthoringChrome(pathname, isTacticoreUnitStructureUxUiEnabled());
}
